import { definePreset } from '@primeuix/themes';
import Lara from '@primeng/themes/lara';

export const GreenOrangePreset =  definePreset(Lara, {
    semantic: {
        primary: {
            50: '{green.50}',
            100: '{green.100}',
            200: '{green.200}',
            300: '{green.300}',
            400: '{green.400}',
            500: '{green.500}',
            600: '{green.600}',
            700: '{green.700}',
            800: '{green.800}',
            900: '{green.900}',
            950: '{green.950}'
        },
        secondary: {
            50: '{orange.50}',
            100: '{orange.100}',
            200: '{orange.200}',
            300: '{orange.300}',
            400: '{orange.400}',
            500: '{orange.500}',
            600: '{orange.600}',
            700: '{orange.700}',
            800: '{orange.800}',
            900: '{orange.900}',
            950: '{orange.950}'
        },
        components : {
            card: {
                borderRadius: '3rem',
            }
        },
        colorScheme: {
            light: {
                text: {
                  color: '#000000'
                },
                overlay: {
                    popover: {
                        background: '{green.100}'
                    }
                },
                surface: {
                    ground: '#ffffff'
                }
            },
            dark: {
                overlay: {
                    popover: {
                        background: '{green.800}'
                    }
                },
                surface: {
                    ground: '{green.950}'
                }
            }
        }
    }
});
